import type { ApolloError } from '@apollo/client';

export const isDisconnected = (error: ApolloError) => {
  return error.graphQLErrors.length === 0 && error.networkError && Object.keys(error.networkError).length === 0;
};
